import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import ProductBadge from "./ProductBadge";

export default function ProductCard({ product }) {
  const finalPrice = (product.price - (product.discount || 0)).toFixed(2);
  const hasDiscount = (product.discount || 0) > 0;
  const inStock = product.keys_available > 0 || product.stock_type === "unlimited";

  return (
    <Link
      data-testid={`product-card-${product.slug}`}
      to={`/products/${product.slug}`}
      className="surface surface-hover group block overflow-hidden"
    >
      <div className="relative aspect-[5/3] overflow-hidden bg-[#0a0a0f]">
        {product.images?.[0] ? (
          <img src={product.images[0]} alt={product.name} className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity" />
        ) : product.logo_text ? (
          <ProductBadge text={product.logo_text} subText={product.logo_text_sub} color={product.logo_color || "#00FF66"} />
        ) : (
          <div className="w-full h-full bg-grid" />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D12] via-transparent to-transparent" />
        <div className="absolute top-3 left-3 chip-mono">
          <span className="w-1.5 h-1.5 rounded-full bg-[#00FF66]" />
          {product.category}
        </div>
        {hasDiscount && (
          <div className="absolute top-3 right-3 font-mono text-[10px] bg-[#00FF66] text-black px-2 py-1 rounded-full font-bold">
            -${product.discount.toFixed(0)}
          </div>
        )}
      </div>
      <div className="p-5">
        <h3 className="font-heading font-semibold text-lg leading-tight group-hover:text-[#00FF66] transition-colors">{product.name}</h3>
        <p className="text-[#A1A1AA] text-sm mt-1 line-clamp-2">{product.description}</p>
        <div className="flex items-center justify-between mt-4">
          <div className="flex items-baseline gap-2">
            <span className="font-mono font-bold text-xl text-[#00FF66]">${finalPrice}</span>
            {product.subscription_period && (
              <span className="font-mono text-[10px] text-[#A1A1AA] uppercase tracking-wider">/{product.subscription_period}</span>
            )}
            {hasDiscount && (
              <span className="font-mono text-xs text-[#71717A] line-through">${product.price.toFixed(2)}</span>
            )}
          </div>
          <div className={`text-xs font-mono flex items-center gap-1 ${inStock ? "text-[#00FF66]" : "text-[#FF3B30]"}`}>
            {inStock ? <><Check className="w-3 h-3" /> in stock</> : "out of stock"}
          </div>
        </div>
        <div className="mt-4 flex items-center gap-1 text-[#00FF66] font-mono text-xs opacity-0 group-hover:opacity-100 transition-opacity">
          view details <ArrowRight className="w-3.5 h-3.5" />
        </div>
      </div>
    </Link>
  );
}
